module.exports = __webpack_public_path__ + "img/banner-contact.1409b62c.png";